<!--
 * @Author: cmchiu
 * @Date: 2022-05-20 16:09:09
 * @LastEditTime: 2022-08-15 15:00:31
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\views\academic\college.vue
 * 
-->
<template>
    <div class="college">
        <section class="section-right-shape padding-bottom padding-top">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mt-20">
                        <breadcrumb />
                    </div>

                    <item-info-ls :datas="dataLs"
                                  v-if="dataLs.length > 0" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { itemInfoLs } from '@c/ItemInfoList'
import { getMenuData } from '@/api/campus'
import { breadcrumb } from '@c/Breadcrumb'

export default {
    name: 'college',

    components: { itemInfoLs, breadcrumb },

    data: function () {
        return {
            dataLs: [],
        }
    },

    created: function () {
        this.getMenuData()
    },

    methods: {
        async getMenuData() {
            await getMenuData({ name: 'academic' }).then(res => {
                if (res.Code === 1) {
                    this.dataLs = res.Items
                }
            })
        },
    },
}
</script>

<style scoped></style>